import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { AutomationRule, AutomationRuleDetails, AutomationRuleIndex, Station } from './automation-rules.model';

@Injectable({
  providedIn: 'root'
})
export class AutomationRulesService {

  constructor(private tmcHttpService: HttpService) { }

  getRules(): Observable<AutomationRule[]> {
    return this.tmcHttpService.postWithContext<AutomationRule[]>(environment.automationRuleAdminEndpoint, {});
  }

  getDetails(ruleId: number): Observable<AutomationRuleDetails> {
    return this.tmcHttpService.postWithContext<AutomationRuleDetails>(environment.automationRuleAdminEndpoint + '/details', ruleId);
  }

  saveDetails(rule: AutomationRuleDetails): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.automationRuleAdminEndpoint + '/save', rule);
  }

  saveRulesIndex(rulesIndices: AutomationRuleIndex[]){
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.automationRuleAdminEndpoint + '/save-indeces', rulesIndices);
  }

  deleteRule(ruleId: number): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.automationRuleAdminEndpoint + '/delete', ruleId);
  }

  getStations(): Observable<Station[]> {
    return this.tmcHttpService.postWithContext<Station[]>(environment.automationRuleAdminEndpoint + '/stations', {});
  }

}
